import { createStyles, Theme } from '@material-ui/core/styles';

const style = (theme: Theme) => createStyles({

    pageContainer: {
        flexGrow: 1,
        padding: `0 ${theme.spacing.unit * 10}px ${theme.spacing.unit * 2}px`,
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'stretch',
        backgroundColor: theme.palette.background.default,
    },

    pageCaption: {
        height: 90,
        display: 'flex',
        alignItems: 'center',
        backgroundColor: theme.palette.background.default,
    },

    pageContent: {
        flexGrow: 1,
        boxShadow: `0px 1px 5px 0px rgba(0,0,0,0.2),
            0px 2px 2px 0px rgba(0,0,0,0.14),
            0px 3px 1px -2px rgba(0,0,0,0.12)
            !important`,
    },

    splitPane: {
        '& .Resizer': {
            width: 3,
            backgroundColor: theme.palette.divider,
        },
    },

    devicesListPane: {
        width: '100%',
        height: '100%',
        display: 'flex',
        flexDirection: 'column',
    },

    devicesList: {
        flexGrow: 1,
        overflow: 'auto',
        borderTop: `1px solid ${theme.palette.divider}`,
    },

    infoBlockTitle: {
        borderTop: `1px solid ${theme.palette.divider}`,
        borderBottom: `1px solid ${theme.palette.divider}`,
    },

    infoBlockBody: {
        overflow: 'auto',
    },

    tableHead: {
        position: 'sticky',
        top: 0,
        background: theme.palette.background.paper,
    },

});

export default style;
